export default {
  labels: {
    warehouseCode: 'Warehouse Code',
    warehouseName: 'Warehouse Name',
    address: 'Address',
    state: 'State',
    city: 'City',
    zipcode: 'Zip Code',
    mobileNumber: 'Mobile Number',
    emailId: 'Email ID',
    location: 'Location',
    countryCode: 'Country Code',
  },
  submitMessages: {
    addWarehouse: 'A New Warehouse Added Successfully.',
  },
  placeholders: {
    enterLocation: 'Enter Location',
  },
};
